/*SUPPLIER*/
export const GET_SUPPLIERS = "GET_SUPPLIERS"
export const GET_SUPPLIERS_SUCCESS = "GET_SUPPLIERS_SUCCESS"
export const GET_SUPPLIERS_FAIL = "GET_SUPPLIERS_FAIL"

export const DELETE_SUPPLIER = "DELETE_SUPPLIER"
export const DELETE_SUPPLIER_SUCCESS = "DELETE_SUPPLIER_SUCCESS"
export const DELETE_SUPPLIER_FAIL = "DELETE_SUPPLIER_FAIL"

export const EDIT_SUPPLIER = "EDIT_SUPPLIER"
export const EDIT_SUPPLIER_SUCCESS = "EDIT_SUPPLIER_SUCCESS"
export const EDIT_SUPPLIER_FAIL = "EDIT_SUPPLIER_FAIL"
export const EDIT_SUPPLIER_CLEAN = "EDIT_SUPPLIER_CLEAN"
/* PROFILE */
export const SAVE_SUPPLIER_PROFILE = "SAVE_SUPPLIER_PROFILE"
export const SAVE_SUPPLIER_PROFILE_SUCCESS = "SAVE_SUPPLIER_PROFILE_SUCCESS"
export const SAVE_SUPPLIER_PROFILE_FAIL = "SAVE_SUPPLIER_PROFILE_FAIL"
export const GET_SUPPLIER_PROFILE = "GET_SUPPLIER_PROFILE"
export const GET_SUPPLIER_PROFILE_SUCCESS = "GET_SUPPLIER_PROFILE_SUCCESS"
export const EXPORT_SUPPLIER = "EXPORT_SUPPLIER"
export const EXPORT_SUPPLIER_SUCCESS = "EXPORT_SUPPLIER_SUCCESS"
export const EXPORT_SUPPLIER_FAIL = "EXPORT_SUPPLIER_FAIL"
export const GET_FILE_REQUIREMENT_SUPPLIER = "GET_FILE_REQUIREMENT_SUPPLIER"
export const GET_FILE_REQUIREMENT_SUPPLIER_SUCCESS =
  "GET_FILE_REQUIREMENT_SUPPLIER_SUCCESS"
export const GET_FILE_REQUIREMENT_SUPPLIER_FAIL =
  "GET_FILE_REQUIREMENT_SUPPLIER_FAIL"
export const DATA_EXPORT_SUPPLIER_CLEAN = "DATA_EXPORT_SUPPLIER_CLEAN"
